import React, { useState } from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import { useQuery } from '@apollo/react-hooks';
import { Loading } from '@components/common';
import { Toggles, AlertTable, PageButtons } from './components';
import { ALERT_SUMMARY_QUERY } from '@api/graphql/manualAlerts';
import { ManualAlert } from '@conviva/portal-graphql-schema';
import usePageTitle from '@src/hooks/usePageTitle';
import AlertForm from '../form';
import { FormActionContext } from '../form/context';
import { Confirmation } from '../shared';
import { getMetricInfo } from '../constants';
import { useActions, InitEditAlert } from './hooks';

const SummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 41px);
  position: relative;
`;

const ManualAlertSummary = () => {
  const [status, setStatus] = useState<string>('all');
  const [visible, setVisible] = useState<boolean>(false);
  const [editAlert, setEditAlert] = useState<{} | ManualAlert>({});
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [alertToDelete, setAlertToDelete] = useState<{} | ManualAlert>({});
  const { loading, data } = useQuery(ALERT_SUMMARY_QUERY());
  let allAlerts = JSON.parse(JSON.stringify(get(data, 'manualAlertsByType', [])));
  const metricsInfo = getMetricInfo();
  allAlerts = allAlerts.map((alert) => {
    if (metricsInfo[alert.metric].units === 'Mbps') {
      alert.threshold = (alert.threshold * 1e-6).toPrecision(3);
    }
    return alert;
  });

  usePageTitle({ text: 'Manual Alerts' });

  const { onCancel, onCancelConfirmation, onDelete, onEdit, onCreate } = useActions({
    setVisible,
    setEditAlert,
    setAlertToDelete,
    setConfirmationVisible,
  });

  InitEditAlert({
    allAlerts,
    setVisible,
    setEditAlert,
  });

  if (loading) {
    return <Loading />;
  }

  const alerts = (() => {
    switch (status) {
      case 'all':
        return allAlerts;
      case 'enabled':
        return allAlerts.filter((a) => a.state);
      case 'disabled':
        return allAlerts.filter((a) => !a.state);
      default:
        return allAlerts;
    }
  })();

  return (
    <FormActionContext.Provider
      value={{
        formVisible: visible,
        actions: {
          onEdit,
          onDelete,
          onCreate,
          onCancel,
        },
      }}
    >
      <SummaryWrapper>
        <PageButtons />
        <Toggles alerts={allAlerts} status={status} setStatus={setStatus} />
        <AlertTable key={JSON.stringify(alerts.map((a) => a.id))} alerts={alerts} />
        <AlertForm
          key={JSON.stringify(editAlert)}
          alert={editAlert}
          visible={visible}
          onCancel={onCancel}
        />
        <Confirmation
          visible={confirmationVisible}
          alert={alertToDelete as ManualAlert}
          onCancel={onCancelConfirmation}
        />
      </SummaryWrapper>
    </FormActionContext.Provider>
  );
};

export default ManualAlertSummary;
